import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.sass']
})
export class SpinnerComponent {

  @Input() spinnerCheckmark = false;
  @Input() svgId: number = Math.floor(Math.random() * (1 + Math.random() * 1000));
}
